import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import edapWrapper from '@homeaway/edap-wrapper';

import './CollapsibleLinkpileCategory.less';
import {
    EDAP_GENERIC_EVENT,
    EDAP_INTERACTION_CLICK,
    EDAP_LINK_CLICK,
    EDAP_COLLAPSIBLE_LINKPILE_ACTION_LOCATION
} from '../../constants';

class Category extends PureComponent {
    handleClick = (e) => {
        const {actionlocation} = this.props;
        edapWrapper().push({
            name: EDAP_GENERIC_EVENT,
            data: {
                actionlocation,
                eventcategory: EDAP_INTERACTION_CLICK,
                eventaction: EDAP_LINK_CLICK,
                eventrefinements: `url=${e.target.href}`
            },
            options: {delayProcessing: true}
        });
    }

    render() {
        const {title, links} = this.props;
        return (
            <div className="CollapsibleLinkpile__category">
                <h3 className="CollapsibleLinkpile__category-title">{title}</h3>
                <ul className="CollapsibleLinkpile__category-list list-inline">
                    {links.map(({url, text}, index) => (
                        <li className="CollapsibleLinkpile__category-list-item" key={index}>
                            <a className="CollapsibleLinkpile__category-link" href={url} onClick={this.handleClick}>{text}</a>
                        </li>
                    ))}
                </ul>
            </div>
        );
    }
}

Category.propTypes = {
    actionlocation: PropTypes.string,
    title: PropTypes.string.isRequired,
    links: PropTypes
        .arrayOf(PropTypes.shape({
            text: PropTypes.string.isRequired,
            url: PropTypes.string.isRequired
        }))
        .isRequired
};

Category.defaultProps = {
    actionlocation: EDAP_COLLAPSIBLE_LINKPILE_ACTION_LOCATION
};

export default Category;
